import { C9rProductDetailConversion } from "../../util/constructorTracking.mjs";
const constructorTrackingGetters = {
  /**
   * Provides Constructor (search platform vendor) beacon
   * user tracking dataset values for the page container
   * based on their "Product detail pages" documentation.
   * https://docs.constructor.com/docs/integrating-with-constructor-behavioral-tracking-data-driven-event-tracking#product-detail-pages
   * @param {string} state.product.brand.name
   * @param {string} state.product.styleId
   * @param {number} state.product.stylePrice.minPrice.value
   * @param {string} state.product.title
   * @param {number} state.selectedPrice.price.value
   * @param {string} getters.computedSelectedSku.skuId
   * @returns C9rProductDetail
   */
  c9rProductDetail(state, getters) {
    var _a, _b;
    const {
      product,
      selectedPrice
    } = state;
    const {
      brand,
      styleId: itemId,
      stylePrice,
      title
    } = product || {};
    const itemName = [brand == null ? void 0 : brand.name, title].filter((val) => typeof val === "string" && val.length).join(" ") || void 0;
    let itemPrice = (_a = selectedPrice == null ? void 0 : selectedPrice.price) == null ? void 0 : _a.value;
    if (!itemPrice && stylePrice) {
      itemPrice = (_b = stylePrice == null ? void 0 : stylePrice.minPrice) == null ? void 0 : _b.value;
    }
    const {
      skuId: itemVariationId
    } = (getters == null ? void 0 : getters.computedSelectedSku) || {};
    return {
      itemId,
      itemName,
      itemPrice,
      itemVariationId
    };
  },
  c9rProductDetailConversion() {
    return C9rProductDetailConversion;
  }
};
export {
  constructorTrackingGetters as default
};
//# sourceMappingURL=constructorTrackingGetters.mjs.map
